import isNil from 'lodash/isNil';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ResetButton } from 'shared/components/buttons/ResetButton/ResetButton';

import { FormControl } from '../../../../../../components/controlledPanels/FormControl/FormControl';
import { NumberInputPanel } from '../../../../../../components/controlledPanels/NumberInputPanel/NumberInputPanel';
import { DEFAULT_OFFSET, DEFAULT_PADDING } from '../../consts';
import type { TooltipConfigProps } from '../TooltipConfig';

export function Layout(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, onUpdateStyle } = props;
  const { t } = useTranslation('components.theme.settings');

  const setPadding = useCallback((newPadding: number) => onUpdateStyle({ padding: newPadding }), [onUpdateStyle]);

  const setOffset = useCallback((newOffset: number) => onUpdateStyle({ offset: newOffset }), [onUpdateStyle]);

  return (
    <FormControl title={t('layout')}>
      <NumberInputPanel
        label={t('padding')}
        value={styles.padding ?? DEFAULT_PADDING}
        onChange={setPadding}
        resetButton={!isNil(styles.padding) && <ResetButton onClick={() => onRemoveStyle('padding')} />}
      />
      <NumberInputPanel
        label={t('offset')}
        value={styles.offset ?? DEFAULT_OFFSET}
        onChange={setOffset}
        resetButton={!isNil(styles.offset) && <ResetButton onClick={() => onRemoveStyle('offset')} />}
      />
    </FormControl>
  );
}
